import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/focus';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { TRANSITION } from '../../../../shared/types/constants/animations';

const LanguageText = styled.div<Props>`
  color: ${Colors['light']};
  cursor: pointer;
  font-family: ${(props) => Fonts[props.focused ? 'regular' : 'thin']};
  font-size: ${35 * Screen.widthRatio}px;
  height: ${45 * Screen.widthRatio}px;
  margin-bottom: ${17 * Screen.widthRatio}px;
  transform: ${(props) => `scale(${props.focused ? '1.1' : '1'})`};
  transition: ${TRANSITION.LANGUAGE_ITEM};
  &:hover {
    font-family: ${Fonts['regular']};
    transform: ${'scale(1.1)'};
  }
`;

export default LanguageText;
